"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.19.0
 */
'use client';

import '../../styled-system/css/css.mjs';
import { cva } from '../../styled-system/css/cva.mjs';
import '../../styled-system/helpers.mjs';

const textAreaRecipe = cva({
  base: {
    w: "full",
    py: "2",
    px: "4",
    rounded: "sm",
    transition: "all",
    transitionDuration: "faster",
    borderWidth: "1px",
    borderColor: "transparent",
    borderStyle: "solid",
    bg: "transparent",
    color: "black",
    _focus: {
      outline: "none"
    },
    _placeholder: {
      color: "neutral.9"
    },
    _disabled: {
      color: "neutral.8",
      _placeholder: {
        color: "neutral.7"
      }
    }
  }
});
const textAreaWrapperRecipe = cva({
  base: {
    display: "grid",
    w: "full",
    overflowY: "hidden",
    _after: {
      content: "attr(data-replicated-value) ' '",
      whiteSpace: "pre-wrap",
      visibility: "hidden",
      maxH: "var(--uikit-textarea-max-height, auto)",
      rounded: "sm",
      px: "4",
      py: "2",
      transition: "all",
      transitionDuration: "faster",
      borderWidth: "1px",
      borderColor: "transparent",
      borderStyle: "solid",
      gridArea: "1 / 1 / 2 / 2"
    },
    "& > textarea": {
      resize: "none",
      overflow: "auto",
      gridArea: "1 / 1 / 2 / 2"
    }
  }
});

export { textAreaRecipe, textAreaWrapperRecipe };
